import { render, staticRenderFns } from "./PayerMenu.vue?vue&type=template&id=04f9ed4f&scoped=true"
import script from "./PayerMenu.vue?vue&type=script&lang=js"
export * from "./PayerMenu.vue?vue&type=script&lang=js"
import style0 from "./PayerMenu.vue?vue&type=style&index=0&id=04f9ed4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f9ed4f",
  null
  
)

export default component.exports